// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version
// MODFIED DATE : 05-09-2025

import RelatedPartiesActionTypes from './related-parties.types';

/** ***************** ADD BUSINESS REALETED PARTIES START *********************** */
export const addBusinessPartiesStart = (partiesData: any) => ({
	type: RelatedPartiesActionTypes.ADD_RELATED_PARTIES_START,
	payload: partiesData,
});

export const addBusinessPartiesSuccess = (successValue: any) => ({
	type: RelatedPartiesActionTypes.ADD_RELATED_PARTIES_SUCCESS,
	payload: successValue,
});

export const addBusinessPartiesFailure = (failureData: any) => ({
	type: RelatedPartiesActionTypes.ADD_RELATED_PARTIES_FAILURE,
	payload: failureData,
});

export const addBusinessPartiesResponseResetStart = () => ({
	type: RelatedPartiesActionTypes.ADD_RELATED_PARTIES_RESPONSE_RESET,
});

export const addBusinessPartiesResponseChanged = () => ({
	type: RelatedPartiesActionTypes.ADD_RELATED_PARTIES_RESPONSE_CHANGED,
});

/** ***************** ADD BUSINESS REALETED PARTIES END *********************** */

/** ***************** UPDATE BUSINESS REALETED PARTIES START *********************** */
export const updateBusinessPartiesStart = (updateData: any) => ({
	type: RelatedPartiesActionTypes.UPDATE_RELATED_PARTIES_START,
	payload: updateData,
});

export const updateBusinessPartiesSuccess = (successData: any) => ({
	type: RelatedPartiesActionTypes.UPDATE_RELATED_PARTIES_SUCCESS,
	payload: successData,
});

export const updateBusinessPartiesFailure = (failureData: any) => ({
	type: RelatedPartiesActionTypes.UPDATE_RELATED_PARTIES_FAILURE,
	payload: failureData,
});

export const updateBusinessPartiesResponseResetStart = () => ({
	type: RelatedPartiesActionTypes.UPDATE_RELATED_PARTIES_RESPONSE_RESET,
});

export const updateBusinessPartiesResponseChanged = () => ({
	type: RelatedPartiesActionTypes.UPDATE_RELATED_PARTIES_RESPONSE_CHANGED,
});

/** ***************** UPDATE BUSINESS REALETED PARTIES END *********************** */

/** ***************** FETCH BUSINESS REALETED PARTIES START *********************** */
export const fetchBusinessPartiesStart = (fetchData: any) => ({
	type: RelatedPartiesActionTypes.FETCH_RELATED_PARTIES_START,
	payload: fetchData,
});

export const fetchBusinessPartiesSuccess = (successData: any) => ({
	type: RelatedPartiesActionTypes.FETCH_RELATED_PARTIES_SUCCESS,
	payload: successData,
});

export const fetchBusinessPartiesFailure = (failureData: any) => ({
	type: RelatedPartiesActionTypes.FETCH_RELATED_PARTIES_FAILURE,
	payload: failureData,
});

export const fetchBusinessPartiesResponseResetStart = () => ({
	type: RelatedPartiesActionTypes.FETCH_RELATED_PARTIES_RESPONSE_RESET,
});

export const fetchBusinessPartiesResponseChanged = () => ({
	type: RelatedPartiesActionTypes.FETCH_RELATED_PARTIES_RESPONSE_CHANGED,
});

/** ***************** FETCH BUSINESS REALETED PARTIES END *********************** */

/** ***************** DELETE BUSINESS REALETED PARTIES START *********************** */
export const deleteBusinessPartiesStart = (fetchData: any) => ({
	type: RelatedPartiesActionTypes.DELETE_RELATED_PARTIES_START,
	payload: fetchData,
});

export const deleteBusinessPartiesSuccess = (successData: any) => ({
	type: RelatedPartiesActionTypes.DELETE_RELATED_PARTIES_SUCCESS,
	payload: successData,
});

export const deleteBusinessPartiesFailure = (failureData: any) => ({
	type: RelatedPartiesActionTypes.DELETE_RELATED_PARTIES_FAILURE,
	payload: failureData,
});

export const deleteBusinessPartiesResponseResetStart = () => ({
	type: RelatedPartiesActionTypes.DELETE_RELATED_PARTIES_RESPONSE_RESET,
});

export const deleteBusinessPartiesResponseChanged = () => ({
	type: RelatedPartiesActionTypes.DELETE_RELATED_PARTIES_RESPONSE_CHANGED,
});
/** ***************** DELETE BUSINESS REALETED PARTIES END *********************** */
